import dropdown from './Dropdown';
import boolean from './Boolean';
import swatch from './Swatches';
import options from './Options';
import list from './List';
import completeForm from './CompleteForm';

export default {
  dropdown,
  boolean,
  swatch,
  options,
  list,
  completeForm,
};



// WEBPACK FOOTER //
// ./src/components/Attributes/standardAttributes/index.js